import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadedBy: {
    id: 'bitbucket.metadataPanel.uploadedBy',
    description: 'Text to label uploaded by info',
    defaultMessage: 'Uploaded by',
  },
});
